import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Modal2fa from '../components/menu/Modal2fa'; 
import Modalpassword from '../components/menu/Modalpassword';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { FormControl,
  Button, Paper, CardContent, Grid, Typography, TextField, 
  Box, CircularProgress, IconButton, InputAdornment, Checkbox, FormControlLabel,
  Snackbar, Alert 
} from "@mui/material";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import KeyIcon from '@mui/icons-material/Key';
import LockPersonRoundedIcon from '@mui/icons-material/LockPersonRounded';
import { grey } from '@mui/material/colors';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AndroidIcon from '@mui/icons-material/Android';
import BASE_URL from '../config'

const contrastBlue = '#A9C7E3'; // Azul Acero Claro

// URL de descarga directa del APK (Google Drive). Se usa el endpoint
// usercontent con confirm=t para evitar la pantalla de aviso de antivirus
// que Drive muestra en archivos grandes.
const APK_URL = 'https://drive.usercontent.google.com/download?id=1QjJ5IqrlHS8St8dKAwKaq1hh1f4GjZCZ&export=download&confirm=t';

export default function Userform() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [user, setUser] = useState({ email: '', user_pass: '' });
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [open2FA, setOpen2FA] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [data2FA, setData2FA] = useState({ userId: null, qrCode: null, setupRequired: false, tempToken: null });
  
  // Notificaciones modernas
  const [notify, setNotify] = useState({ open: false, msg: '', sev: 'error' });
  const showMsg = (msg, sev = 'error') => setNotify({ open: true, msg, sev });

  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email);
  const isPassValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(user.user_pass);


  useEffect(() => {
    const savedEmail = localStorage.getItem('rememberedEmail');
    setShowErrors(false);
    if (savedEmail) {
      setUser(prev => ({ ...prev, email: savedEmail }));
      setRememberMe(true);
    }
  }, []);

  const handleChange = (e) => setUser({ ...user, [e.target.name]: e.target.value });

  const handleAuth = async (type) => {
    if (!user.email || !user.user_pass) {
      return showMsg("Email y contraseña son obligatorios.");
    }
    if (type === 'register') {
      if (!isEmailValid) {
        return showMsg("El formato del correo electrónico no es válido.");
      }
      if (!isPassValid) {
        return showMsg("La contraseña no cumple con los requisitos mínimos.");
      }
    }
    const isTrusted = localStorage.getItem(`trusted_${user.email}`) === 'true';
    setLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/auth/${type}`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
        ...user, 
        remember: rememberMe ,
        isTrustedDevice: isTrusted
      }),
    });
      const data = await res.json();
      if (res.ok) {
        if (type === 'register' || data.require2fa) {
          setData2FA({ 
            userId: data.userId, 
            qrCode: data.qrCode || null, 
            setupRequired: data.setupRequired || (type === 'register'),
            tempToken: data.token || null
          });
          setOpen2FA(true);
        } else {
          if (data.user) {
                localStorage.setItem('user', JSON.stringify(data.user));
            }
            onFinalSuccess(data.token);
        }
      } else {
        showMsg(data.message || "Error de acceso");
      }
    } catch (e) {
      showMsg("Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  const onFinalSuccess = (token) => {
    if (rememberMe){ 
      localStorage.setItem('rememberedEmail', user.email);
      localStorage.setItem(`trusted_${user.email}`, 'true');
    } else{
      localStorage.removeItem('rememberedEmail');
      localStorage.removeItem(`trusted_${user.email}`);
    }
    localStorage.setItem('token', token);
    navigate('/home/menu');
  };

  const Inputstyle = {
    '& .MuiOutlinedInput-root': {
      bgcolor: '#f5f5f5',
      borderRadius: '8px',
      '& fieldset': { borderColor: 'transparent' },
      '&:hover fieldset': { borderColor: grey[400] },
      '&.Mui-focused fieldset': { borderColor: grey[600] },
    },
  };

  return (
    <Box sx={{
          minHeight: '100vh',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          overflow: 'hidden',
          bgcolor: '#F8F9FA', 
          backgroundImage: `radial-gradient(at 0% 0%, hsla(210,100%,95%,1) 0, transparent 50%), 
                            radial-gradient(at 100% 100%, hsla(210,100%,90%,1) 0, transparent 50%)`,
          '@keyframes fadeInUp': {
            from: { opacity: 0, transform: 'translateY(20px)' },
            to: { opacity: 1, transform: 'translateY(0)' },
          }
        }}>
      <Grid container direction="column" alignItems="center" justifyContent="center">
        <Paper 
        sx={{ 
          m: 3,
          borderRadius: 9, 
          width: '90%', 
          maxWidth: 420,
          zIndex: 1,
          position: 'relative',

          bgcolor: 'rgba(255, 255, 255, 0.5)',
          backdropFilter: 'blur(20px) saturate(140%)',
          
          // El Borde: Usamos el azul acero para que combine con los grises
          border: `1.5px solid ${contrastBlue}`, 
          
          // Sombra multinivel para dar profundidad real
          boxShadow: `
            0 4px 6px -1px rgba(0, 0, 0, 0.05), 
            0 20px 25px -5px rgba(0, 0, 0, 0.08),
            inset 0 0 15px rgba(255, 255, 255, 0.6)
          `,
        }}>
          <CardContent>
            <Box sx={{ display:"flex", gap:2, flexDirection:'column', mx:3 }}>
              <Box textAlign="center" mb={1}>
                <IconButton disableRipple sx={{ my:2, pointerEvents: "none", color: "white", transform: "scale(1.2)", backgroundColor: "black" }}>
                  <LockPersonRoundedIcon />
                </IconButton>
                <Typography variant="h6" margin='10px 0'>
                  {mode === 'login' ? 'Iniciar Sesión' : 'Crear Cuenta'}
                </Typography>
                <Typography variant="body1" sx={{mx:3}} textAlign="center" color="Grey">
                  {mode === 'login'
                    ? 'Ingresa tus credenciales para acceder a tu cuenta'
                    : 'Regístrate para crear una cuenta nueva'}
                </Typography>
              </Box>

              <FormControl fullWidth>
                <Typography>Correo Electrónico</Typography>
                <TextField fullWidth name="email" 
                placeholder="tu@ejemplo.com" 
                variant="outlined" 
                sx={Inputstyle} 
                value={user.email} 
                onChange={handleChange} 
                error={(user.email.length > 0 && !isEmailValid) || (showErrors && user.nombre_completo === '')}
                helperText={user.email.length > 0 && !isEmailValid ? "Ingresa un correo válido con el formato ****@ejemplo.piper" : (showErrors && user.user_pass === '' ? "Campo obligatorio" : "")}
                autoComplete=""
                  inputProps={{ maxLength: 30 }}
                  slotProps={{ input: 
                    { startAdornment: <InputAdornment position="start"><MailOutlineOutlinedIcon /></InputAdornment> } }} 
                />
              </FormControl>
              
              <FormControl fullWidth>
                <Typography>Contraseña</Typography>
                <TextField 
                    // 1. Mantenemos el cambio de tipo dinámico
                    inputProps={{ maxLength: 20 }}
                    type={showPassword ? 'text' : 'password'} 
                    fullWidth 
                    name='user_pass' 
                    onChange={handleChange} 
                    value={user.user_pass}
                    placeholder="Contraseña"
                    error={(mode === 'register' && user.user_pass.length > 0 && !isPassValid) || (showErrors && user.user_pass === '')}
                    helperText={
                      mode === 'register' && user.user_pass.length > 0 && !isPassValid
                        ? "Mínimo 8 caracteres, 1 mayúscula y 1 número"
                        : (showErrors && user.user_pass === '' ? "Campo obligatorio" : "")
                    }

                    sx={{ 
                      ...Inputstyle, 
                      '& input::-ms-reveal': { display: 'none' }, 
                      '& input::-ms-clear': { display: 'none' },
                    }}

                    // 3. Verificamos que InputProps esté bien formado
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><KeyIcon /></InputAdornment>,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end">
                            {showPassword ? <VisibilityOff fontSize="medium" /> : <Visibility fontSize="medium" />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
              </FormControl>

              {mode === 'register' && (
                <Box sx={{ maxWidth:450, display: 'flex', alignItems:'center', gap: 1, mt: 1, p: 1, bgcolor: '#fdf8f3', borderRadius: 1, border: '1px solid #faead1' }}>
                  <InfoOutlinedIcon sx={{ fontSize: 16, color: '#b78103' }} />
                  <Typography variant="caption" sx={{ color: '#664d03', lineHeight: 1.2 }}>
                    Para crear una cuenta, la contraseña debe ser mayor a 8 caracteres, incluir una mayúscula, una minúscula y un número.
                  </Typography>
                </Box>
              )}

              {mode === 'login' && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <FormControlLabel sx={{ color:"rgba(0, 0, 0, 0.4)", ':hover':{ color:grey[800] } }}
                    control={<Checkbox sx={{ color: grey[400], '&.Mui-checked': { color: grey[600] } }} checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />}
                    label='Recordarme'
                  />
                  <Modalpassword />
                </Box>
              )}

              <Button size="large" sx={{ borderRadius:'8px', bgcolor:'black', textTransform:'none' }} variant="contained" fullWidth onClick={() => handleAuth(mode)} disabled={loading}>
                {loading ? <CircularProgress size={24} color="inherit" /> : (mode === 'login' ? 'Iniciar Sesión' : 'Crear Cuenta')}
              </Button>

              {/* Cambiar entre iniciar sesión / registro (link, estilo común) */}
              <Typography variant="body2" textAlign="center" sx={{ color: grey[700] }}>
                {mode === 'login' ? '¿No tienes cuenta? ' : '¿Ya tienes cuenta? '}
                <Box component="span"
                  onClick={() => setMode(mode === 'login' ? 'register' : 'login')}
                  sx={{ color: 'black', fontWeight: 'bold', cursor: 'pointer', textDecoration: 'underline' }}>
                  {mode === 'login' ? 'Regístrate' : 'Inicia sesión'}
                </Box>
              </Typography>

              <Button component="a" href={APK_URL} target="_blank" rel="noopener noreferrer" fullWidth size="large" startIcon={<AndroidIcon/>}
                sx={{ borderRadius:'8px', bgcolor:'white', textTransform:"none", color: 'black', border: '1px solid #eee' }}>
                Descargar app móvil (Android)
              </Button>
            </Box>
          </CardContent>
        </Paper>
        
        <Modal2fa open={open2FA} setOpen={setOpen2FA} data2FA={data2FA} setData2FA={setData2FA} onSuccess={onFinalSuccess} />
        
        <Snackbar open={notify.open} autoHideDuration={3000} onClose={() => setNotify({ ...notify, open: false })} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert severity={notify.sev} variant="filled" sx={{ width: '100%' }}>{notify.msg}</Alert>
        </Snackbar>
      </Grid>
    </Box>
  );
}